<template>
  <div class="container-fluid vld-parent">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="card min-h-350">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <img
                v-if="data.usr_photo == null"
                class="rounded-circle details-employee-user mr-3"
                src="@/assets/user.png"
                alt="Header Avatar"
              />
              <img
                v-else
                :src="this.$root.backEnd + data['usr_photo']"
                alt="profile"
                class="rounded-circle details-profile-user mr-3"
              />
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mb-1">
                  {{ data.usr_fullname }}
                </h5>
                <p class="text-muted mb-0">
                  Join date
                  {{ $moment(data.created_at).format("HH:mm, DD MMMM YYYY") }}
                </p>
              </div>
            </div>

            <!-- <h5 class="font-size-15 mt-4">Descriptions</h5> -->

            <!-- <p
              class="text-muted mb-4"
            >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi voluptate laudantium, cum quae eius ab numquam fuga. Facilis ea ratione dignissimos quam quaerat fugiat doloribus? Autem et tempora magnam maiores!</p>-->
            <div class="table-responsive mt-4">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Email</th>
                    <td>{{ data.usr_email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Phone Number</th>
                    <td>{{ data.usr_phone }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alamat</th>
                    <td>{{ data.usr_address }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card min-h-350">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Car List</h4>
              <button
                type="button"
                class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                @click="qucikCreateShow(true)"
              >
                <i class="bx bx-plus mr-2"></i> New Car
              </button>
            </div>
            <div class="mt-4">
              <div class="vld-parent">
                <loading
                  :active.sync="isLoading"
                  :is-full-page="false"
                ></loading>
                <div class="table-responsive" v-if="dataCars.total_data != 0">
                  <table
                    class="table table-centered table-striped table-bordered table-nowrap mb-0"
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th style="width: 70px"></th>
                        <th
                          v-for="(item, index) in fieldsCars"
                          :key="index + '-fieldsCars'"
                        >
                          <div
                            @click="
                              sortAction(item['cst_crs_f_name'], sortCars)
                            "
                            class="d-flex align-items-center justify-content-between"
                            style="cursor: pointer"
                          >
                            {{ item["cst_crs_f_label"] }}
                            <template
                              v-if="orderByCars == item['cst_crs_f_name']"
                            >
                              <template v-if="sortCars == 'asc'">
                                <i class="bx bx-sort-a-z"></i>
                              </template>
                              <template v-else>
                                <i class="bx bx-sort-z-a"></i>
                              </template>
                            </template>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in dataCars['data']"
                        :key="index"
                      >
                        <td>
                          <button
                            @click="editCars(item['cst_crs_uuid'])"
                            type="button"
                            class="btn btn-link btn-rounded waves-effect"
                          >
                            <i class="bx bx-edit-alt"></i>
                          </button>
                          <!-- <button
                            @click="showAlert(item['cst_crs_uuid'])"
                            type="button"
                            class="btn btn-link btn-rounded waves-effect"
                          >
                            <i class="bx bx-trash"></i>
                          </button> -->
                        </td>
                        <td
                          v-for="(item_fields, index_fields) in fieldsCars"
                          :key="index_fields"
                          :class="
                            item_fields['cst_crs_f_name'] == 'crs_model_id' ||
                            item_fields['cst_crs_f_name'] == 'prd_id' ||
                            item_fields['cst_crs_f_name'] ==
                              'srv_b_description' ||
                            item_fields['cst_crs_f_name'] == 'ts_keluhan' ||
                            item_fields['cst_crs_f_name'] == 'ts_tindakan'
                              ? 'specifictd'
                              : ''
                          "
                        >
                          <template
                            v-if="
                              item_fields['cst_crs_f_name'] == 'crs_brand_id'
                            "
                          >
                            <template v-if="Array.isArray(item.crs_brand_id)">
                              <router-link
                                v-for="(x, y) in item[
                                  item_fields['cst_crs_f_name']
                                ]"
                                :key="y + '_crs_brand_id'"
                                class="mr-1"
                                target="_blank"
                                :to="{
                                  name: 'cars_brand_detail',
                                  params: { uuid: x['crs_brand_uuid'] },
                                }"
                                >{{ x.crs_brand_name }}
                                {{
                                  item[item_fields["cst_crs_f_name"]].length !=
                                  y + 1
                                    ? ", "
                                    : ""
                                }}</router-link
                              >
                            </template>
                            <template v-else>
                              <router-link
                                :to="{
                                  name: 'cars_brand_detail',
                                  params: { uuid: item['crs_brand_uuid'] },
                                }"
                                >{{ item["crs_brand_name"] }}</router-link
                              >
                            </template>
                          </template>
                          <template
                            v-else-if="
                              item_fields['cst_crs_f_name'] == 'crs_model_id'
                            "
                          >
                            <template v-if="Array.isArray(item.crs_model_id)">
                              <router-link
                                v-for="(x, y) in item[
                                  item_fields['cst_crs_f_name']
                                ]"
                                :key="y + '_crs_model_id'"
                                class="mr-1"
                                target="_blank"
                                :to="{
                                  name: 'cars_model_detail',
                                  params: { uuid: x['crs_model_uuid'] },
                                }"
                                >{{ x.crs_model_name }}
                                {{
                                  item[item_fields["cst_crs_f_name"]].length !=
                                  y + 1
                                    ? ", "
                                    : ""
                                }}</router-link
                              >
                            </template>
                            <template v-else>
                              <router-link
                                :to="{
                                  name: 'cars_model_detail',
                                  params: { uuid: item['crs_model_uuid'] },
                                }"
                                >{{ item["crs_model_name"] }}</router-link
                              >
                            </template>
                          </template>

                          <template
                            v-else-if="
                              item_fields['cst_crs_f_input_type'] == 's_image'
                            "
                          >
                            <img
                              class="details-profile-user"
                              :src="
                                $root.backEnd +
                                item[item_fields['cst_crs_f_name']]
                              "
                              v-if="item[item_fields['cst_crs_f_name']] != null"
                              alt
                            />
                          </template>
                          <template v-else>{{
                            item[item_fields["cst_crs_f_name"]]
                          }}</template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Transactions</h4>
            </div>

            <div
              class="mt-3 height-600px"
              v-for="(item, index) in dataTrans['data']"
              :key="index"
            >
              <div class="card shadow-sm mb-2">
                <div class="card-body">
                  <div class="mb-4 justify-content-between d-flex">
                    <div>
                      <h5 class="font-size-15">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'services_transaction_invoice',
                            params: { uuid: item.srv_t_uuid },
                          }"
                          >{{ item["srv_t_code"] }}</router-link
                        >
                      </h5>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between border-bottom pb-2 mb-2"
                  >
                    <div class>
                      <h5 class="font-size-12 text-muted">Kategori</h5>
                      <p class="font-size-12 text-primary mb-0">
                        <b>{{ item["srv_t_cat_name"] }}</b>
                      </p>
                    </div>
                    <div class="text-right">
                      <h5 class="font-size-12 text-muted">
                        Waktu Selesai
                      </h5>
                      <p class="text-muted mb-0">
                        <template v-if="item.srv_t_status == 1">
                          <template v-if="item.updated_at !== null && item.updated_at">
                            {{ item.srv_t_updated_at }}
                          </template>
                          <template v-else>
                            {{ item.srv_t_created_at }}
                          </template>
                        </template>
                        <template v-else>
                          Belum Diselesaikan
                        </template>
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between border-bottom pb-2 mb-2"
                  >
                    <div class>
                      <h5 class="font-size-12 text-muted">Status</h5>
                      <p class="font-size-12 text-danger mb-0">
                        <b>{{ item["srv_t_status_name"] }}</b>
                      </p>
                    </div>
                    <div class="text-right">
                      <h5 class="font-size-12 text-muted">Tanggal Booking</h5>
                      <p class="text-muted mb-0">{{ item["srv_t_date"] }}</p>
                    </div>
                  </div>

                  <div
                    class="justify-content-between d-flex align-items-center mt-3"
                  >
                    <h5 class="font-size-12 mb-0 text-muted">Kilometer</h5>
                    <p class="font-weight-bold mb-0">
                      {{ numberWithCommas(item["srv_t_km"]) }}
                    </p>
                  </div>
                  <div
                    class="justify-content-between d-flex align-items-center mt-3"
                  >
                    <h5 class="font-size-12 mb-0 text-muted">DP</h5>
                    <p class="font-weight-bold mb-0">
                      Rp {{ numberWithCommas(item["srv_t_dp"]) }}
                    </p>
                  </div>
                  <div
                    class="justify-content-between d-flex align-items-center mt-3"
                  >
                    <h5 class="font-size-12 mb-0">Total Price</h5>
                    <p class="font-weight-bold mb-0">
                      Rp {{ numberWithCommas(item["srv_t_actual_price"]) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-flex align-items-center w-100 bg-light mt-3 mb-3 h-350"
              v-if="dataTrans['total_data'] == 0"
            >
              <div class="m-auto text-center mini-stats-wid">
                <div
                  class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
                >
                  <span class="avatar-title">
                    <i class="bx bx-search-alt font-size-2"></i>
                  </span>
                </div>
                <h5 class="mt-3">No Transactions</h5>
                <p class="mb-0">Please make new a transaction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <quickCreate
      v-if="childDataLoaded"
      :visible="visible"
      :fields="fieldsCars"
      module="Customers Cars"
      table_module="customers_cars"
      alias_table="cst_crs"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{ cst_id: data.usr_id }"
    ></quickCreate>

    <b-sidebar
      :visible="visibleEditCustomer"
      id="sidebar-edit-customers"
      title="Edit Customers"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      @hidden="visibleEditCustomer = false"
    >
      <template v-if="visibleEditCustomer">
        <div class="px-3 py-2">
          <form class="form-sample" @submit.prevent="updateCustomersCars()">
            <!-- <p class="card-description">Personal info</p> -->
            <div class="row">
              <div
                class="col-md-12"
                v-for="(item, index) in fieldsCarsEdit"
                :key="index + '_fieldsCustomers'"
              >
                <div class="form-group">
                  <label>{{ item["cst_crs_f_label"] }}</label>
                  <small
                    v-if="item['cst_crs_f_validation'] != ''"
                    class="pull-right text-danger"
                    >*{{ item["cst_crs_f_validation"] }}</small
                  >
                  <component
                    :is="item['cst_crs_f_input_type'] + '_form'"
                    :name="item['cst_crs_f_name']"
                    :validation="item['cst_crs_f_validation']"
                    :content="item['content']"
                    :dropdown_name="item['cst_crs_f_options']"
                    @post="bindingDataCustomers"
                  ></component>
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary mr-2">Update</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="visibleEditCustomer = false"
            >
              Cancel
            </button>
          </form>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import quickCreate from "@/components/quick_create";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import s_image_form from "@/components/input/s_image";
import year_form from "@/components/input/year";
import { Money } from "v-money";

export default {
  data() {
    return {
      module: "Pengguna",
      table_module: "customers",
      alias_table: "usr",
      data: {},
      post: {
        usr_role: 2,
      },
      error: {},
      uuid: this.$route.params.uuid,
      dataCars: {},
      fieldsCars: {},
      dataTrans: {},
      fieldsTrans: {},
      cst_id: null,
      fields_customers_cars: {},
      post_customers_cars: {},
      trigger_autocomplete: "",
      isLoading: true,
      visible: false,
      childDataLoaded: false,
      orderByCars: "created_at",
      sortCars: "desc",
      visibleEditCustomer: false,
      post_customers: {},
      fieldsCarsEdit: [],
    };
  },
  components: {
    quickCreate,
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    s_image_form,
    Money,
    year_form,
  },
  methods: {
    updateCustomersCars() {
      this.axios
        .post(
          "customers_cars/update/" + this.post_customers_cars.cst_crs_uuid,
          this.post_customers_cars
        )
        .then((response) => {
          console.log(response);
          this.visibleEditCustomer = false;
          this.getCstCrs(this.post_customers_cars.cst_id);
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    getKeyByname(name = "") {
      return this.fields.findIndex((r) => r["usr_f_name"] == name);
    },
    getCstCrs(id = "") {
      this.fieldsCars = {};
      var params = {};

      if (id != "") {
        params = {
          ["filter[cst_id]"]: id,
        };
      }

      params["order_by"] = this.orderByCars;
      params["type_sort"] = this.sortCars;

      this.axios
        .get("/customers_cars", { params: params })
        .then((response) => {
          this.dataCars = response.data.data["customers_cars"];
          this.fieldsCars = response.data.data["fields"];
          this.childDataLoaded = true;
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    getHistTrans(id = "") {
      var params = {};

      if (id != "") {
        params = {
          ["filter[cst_id]"]: id,
        };
      }

      this.axios
        .get("/services_transaction", { params: params })
        .then((response) => {
          this.dataTrans = response.data.data["services_transaction"];
          this.fieldsTrans = response.data.data["fields"];
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    fetchData() {
      this.axios
        .get("/users/detailbyAdmin/" + this.uuid)
        .then((response) => {
          this.data = response.data.data;
          this.getCstCrs(response.data.usr_id);
          this.getHistTrans(response.data.usr_id);
          this.cst_id = response.data.usr_id;
          this.$set(this.post_customers_cars, "cst_id", response.data.usr_id);
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    getType() {
      var type = "";
      if (this.dataTrans.srv_t_type == 1) {
        type = "srv";
      } else {
        type = "srv_b";
      }

      return type;
    },
    sortAction(name, sort) {
      this.sortCars = sort == "asc" ? "desc" : "asc";
      this.orderByCars = name;
      this.getCstCrs(this.cst_id);
    },
    editCars(uuid = "") {
      this.visibleEditCustomer = true;
      this.$set(this.post_customers_cars, "cst_crs_uuid", uuid);
      this.axios
        .get("/customers_cars/edit/" + uuid)
        .then((response) => {
          this.fieldsCarsEdit = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    bindingDataCustomers: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers_cars, value["name"]);
      } else {
        this.$set(this.post_customers_cars, value["name"], value["value"]);
      }
    },
  },
  mounted() {
    if (typeof this.$route.query.page !== "undefined") {
      this.page = this.$route.query.page;
    }
    if (typeof this.$route.query.limit !== "undefined") {
      this.limit = this.$route.query.limit;
    }
    if (typeof this.$route.query.orderBy !== "undefined") {
      this.orderBy = this.$route.query.orderBy;
    }
    if (typeof this.$route.query.sort !== "undefined") {
      this.sort = this.$route.query.sort;
    }
    this.fetchData();
  },
};
</script>